var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53196 19.0093L3.51186 19.0293C3.24049 18.4393 3.06962 17.7693 2.99927 17.0293C3.06962 17.7593 3.26059 18.4193 3.53196 19.0093Z",
    fill: "#0095DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98461 10.3791C11.3057 10.3791 12.3767 9.31358 12.3767 7.99914C12.3767 6.6847 11.3057 5.61914 9.98461 5.61914C8.6635 5.61914 7.59253 6.6847 7.59253 7.99914C7.59253 9.31358 8.6635 10.3791 9.98461 10.3791Z",
    fill: "#0095DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2113 2H8.78871C5.13023 2 2.94922 4.17 2.94922 7.81V16.19C2.94922 17.28 3.14018 18.23 3.51206 19.03C4.37643 20.93 6.22577 22 8.78871 22H17.2113C20.8697 22 23.0507 19.83 23.0507 16.19V13.9V7.81C23.0507 4.17 20.8697 2 17.2113 2ZM21.4125 12.5C20.6285 11.83 19.3621 11.83 18.5782 12.5L14.397 16.07C13.6131 16.74 12.3467 16.74 11.5627 16.07L11.221 15.79C10.5074 15.17 9.37166 15.11 8.56759 15.65L4.80861 18.16C4.58749 17.6 4.45683 16.95 4.45683 16.19V7.81C4.45683 4.99 5.9544 3.5 8.78871 3.5H17.2113C20.0456 3.5 21.5431 4.99 21.5431 7.81V12.61L21.4125 12.5Z",
    fill: "#0095DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/icon_gallery.5da0286e42b3c1def3dbd80db9bdf085.svg";
export { ForwardRef as ReactComponent };